/**
 *
 * Panel
 *
 */
import React, { useRef } from 'react';
import styled from 'styles/styled-components';
import useOnClickOutside from 'use-onclickoutside';
import { FiX } from 'react-icons/fi';
import { animated as a, useTransition } from 'react-spring';
import useMedia from 'use-media';
// eslint-disable-next-line import/named
import { css } from 'styled-components/macro';

interface Props {
  children?: React.ReactNode;
  close?: any;
  isVisible: boolean;
  autoclose?: boolean;
  animation?: boolean;
  className?: string;
}

function Panel({
  children,
  close,
  autoclose,
  isVisible,
  animation = true,
  className,
}: Props) {
  const ref = useRef(null);
  useOnClickOutside(ref, () => {
    if (autoclose && close) {
      close();
    }
  });
  const isMobile = useMedia({ maxWidth: 1023 });

  const transitionsDown = useTransition(isVisible, null, {
    config: { mass: 1, tension: 130, friction: 18 },
    from: { opacity: 0, transform: 'translate3d(0,-70%,0)' },
    enter: { opacity: 1, transform: 'translate3d(0,0%,0)' },
    leave: { opacity: 0, transform: 'translate3d(0,-60%,0)' },
  });

  const transitionsUp = useTransition(isVisible, null, {
    config: { mass: 1, tension: 130, friction: 18 },
    from: { opacity: 0, transform: 'translate3d(0,70%,0)' },
    enter: { opacity: 1, transform: 'translate3d(0,0%,0)' },
    leave: { opacity: 0, transform: 'translate3d(0,60%,0)' },
  });

  let transitions = undefined;
  if (isMobile) {
    transitions = transitionsUp;
  } else {
    transitions = transitionsDown;
  }

  if (animation) {
    return (
      <>
        {transitions.map(
          ({ item, key, props }) =>
            item && (
              <div className="w-full" key={key}>
                <AnimatedStyledPanel
                  ref={ref}
                  key={key}
                  className={`bg-secondary container ${
                    className ? className : ''
                  }`}
                  style={props}
                  mobile={isMobile ? 1 : 0}
                >
                  {children}
                  {close && (
                    <div className="absolute right-0 top-0 mr-2">
                      <button onClick={close} className="p-2">
                        <FiX className="h-6 w-6" />
                      </button>
                    </div>
                  )}
                </AnimatedStyledPanel>
              </div>
            ),
        )}
      </>
    );
  } else if (isVisible) {
    return (
      <div className="">
        <AnimatedStyledPanel
          ref={ref}
          className={`bg-secondary container ${className}`}
          mobile={isMobile ? 1 : 0}
        >
          <div className="">{children}</div>
          {close && (
            <div className="absolute right-0 top-0 mr-2">
              <button onClick={close} className="p-2">
                <FiX className="h-6 w-6" />
              </button>
            </div>
          )}
        </AnimatedStyledPanel>
      </div>
    );
  }
  return null;
}

export default Panel;

const AnimatedStyledPanel = styled(a.div)<{ mobile: number }>`
  width: 100%;
  height: 9rem;
  margin-left: auto;
  margin-right: auto;
  z-index: 40000;

  ${p =>
    p.mobile
      ? css`
          position: fixed;
          bottom: 0;
          height: 13.5rem;
        `
      : css`
          position: absolute;
          top: 0;
        `}
`;
